import type { FC } from "react";

import type { TrackerCategory } from "../../common/tracking/trackerService";
import { CopyButton } from "../../use-cases/intermodal/common/ValueTxt";
import {
  type TrackerAction,
  useTrackingTextInput,
} from "../../use-cases/simple-create/hooks/UseTrackingTextInput";
import {
  NumericTextInput,
  type NumericTextInputProps,
} from "./NumericTextInput";

export interface CommonNumericTextInputProps extends NumericTextInputProps {
  changed?: boolean;
  isValid?: boolean;
  showCopyButton?: boolean;
  trackerAction: TrackerAction;
  trackerCategory: TrackerCategory;
}

export const CommonNumericTextInputField: FC<CommonNumericTextInputProps> = ({
  isValid = true,
  trackerCategory,
  trackerAction,
  changed,
  value,
  disabled,
  showCopyButton = false,
  ...props
}) => {
  const { onBlur, onFocus } = useTrackingTextInput(
    trackerAction,
    trackerCategory,
  );

  return (
    <NumericTextInput
      variant={!isValid ? "error" : undefined}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={disabled}
      buttonRight={
        showCopyButton && value ? (
          <CopyButton getValue={() => String(value)} />
        ) : undefined
      }
      value={value}
      style={{
        fontStyle: changed ? "italic" : "normal",
        fontWeight: changed ? "bold" : "normal",
      }}
      {...props}
    />
  );
};
